import React, { useState, useEffect } from "react";

// bootstrap
import { Image } from "react-bootstrap";

// app left menu styles
import "./styles/app-left-menu-styles.scss";

// icons : feather
import FeatherIcon from "feather-icons-react";

// logo
// import appLogo from "assets/images/logo.png";
import appLogo from "assets/images/logo.svg";

// react router
import { Link, NavLink } from "react-router-dom";

// redux
import { connect, useSelector } from "react-redux";

// actions
import { setSideBarStatus } from "redux/actions/actionCommon";

import useStoreUrl from "utlis/CustomHooks/useStoreUrl/";

function AppLeftMenu(props) {
	// states
	const [openedDropdowns, setOpenedDropdowns] = useState([]);
	
	const [storeUrl] = useStoreUrl()

	// toggle submenu in the left menu
	const handleSubMenuVisibility = (ev, dataId) => {
		ev.preventDefault();

		const dataIdExists = openedDropdowns.find((item) => item === dataId);
		if (dataIdExists) {
			const filteredDropdowns = openedDropdowns.filter(
				(item) => item !== dataId
			);

			// updating the opened dropdown list
			setOpenedDropdowns([...filteredDropdowns]);

			setTimeout(() => { }, 1500);
		} else {
			// updating the opened dropdown list
			setOpenedDropdowns([...openedDropdowns, dataId]);

			setTimeout(() => { }, 1500);
		}
	};

	// toggle menu expand or normal
	const handleMenuExpantion = () => {
		props.setSideBarStatus(!props.sideBarVisibility);

		// closing all the opened dropdowns
		// setOpenedDropdowns([])
	};

	const handleMenuButtonMouseEnter = (ev) => {
		if (!props.sideBarVisibility) {
			ev.stopPropagation();
		}
	};

	const handleSimpleLinkClick = () => {
		// updating the opened dropdown list
		setOpenedDropdowns([]);
	};

	return (
		<div
			className={`app-left-menu ${props.sideBarVisibility ? "shrunk" : "expanded"
				}`}
		>
			<div className="inner bg-white h-100 border-end st-border-light">
				{/* logo */}
				<div className="st-logo d-flex align-items-center border-bottom st-border-light">
					<Link
						to={storeUrl + "/dashboard"}
						className="d-block"
						onClick={handleSimpleLinkClick}
					>
						<Image src={appLogo} fluid />
					</Link>

					<button
						className={`st-round-btn st-btn-transparent st-btn-sm d-flex align-items-center justify-content-center ${props.sideBarVisibility ? "menu-shrunk" : "expanded"
							}`}
						onMouseEnter={handleMenuButtonMouseEnter}
						onClick={handleMenuExpantion}
					>
						<FeatherIcon icon="menu" size="18" className="icon" />
					</button>
				</div>
				{/* NAV ITEM */}
				<div className="alm_nav-item">
					{/* NAV LINK */}
					<NavLink
						data-id="1"
						to={storeUrl + "/dashboard"}
						activeClassName="opened"
						className="alm_nav-link text-decoration-none d-flex align-items-center"
						onClick={handleSimpleLinkClick}
					>
						{/* left sec */}
						<div className="lt d-flex media-body">
							<FeatherIcon icon="home" size="15" className="icon" />
							<span>Dashboard</span>
						</div>
					</NavLink>
				</div>

				{/* NAV ITEM */}
				<div className="alm_nav-item">
					{/* NAV LINK */}
					<Link
						data-id="2"
						to={`${storeUrl}/my-sales/customers`}
						className={`
                            alm_nav-link text-decoration-none d-flex align-items-center
                            ${openedDropdowns.find((item) => item === "2")
								? "active"
								: ""
							}
                        `}
						onClick={(ev) => handleSubMenuVisibility(ev, "2")}
					>
						{/* left sec */}
						<div className="lt d-flex media-body">
							<FeatherIcon icon="trending-up" size="15" className="icon" />
							<span>My Sales</span>
						</div>

						{/* right sec */}
						<div className="rt text-center">
							<FeatherIcon icon="chevron-right" size="15" className="icon" />
						</div>
					</Link>

					{
						/* sub menu */
						openedDropdowns.find((item) => item === "2") && (
							<div className="alm_sub-menu">
								{/* SUB NAV ITEM */}
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/my-sales/customers`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Customers
									</NavLink>
								</div>

								{/* SUB NAV ITEM */}
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/customers/groups`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Customer Group
									</NavLink>
								</div>

								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/my-sales/sale-orders`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Sale Orders
									</NavLink>
								</div>

								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/my-sales/abandoned-carts`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Abandoned Carts
									</NavLink>
								</div>
							</div>

						)
					}
				</div>

				{/* NAV ITEM */}
				<div className="alm_nav-item">
					{/* NAV LINK */}
					<Link
						data-id="3"
						to="/dashboard"
						className={`
                            alm_nav-link text-decoration-none d-flex align-items-center
                            ${openedDropdowns.find((item) => item === "3")
								? "active"
								: ""
							}
                        `}
						onClick={(ev) => handleSubMenuVisibility(ev, "3")}
					>
						{/* left sec */}
						<div className="lt d-flex media-body">
							<FeatherIcon icon="book" size="15" className="icon" />
							<span>Catalog</span>
						</div>

						{/* right sec */}
						<div className="rt text-center">
							<FeatherIcon icon="chevron-right" size="15" className="icon" />
						</div>
					</Link>

					{
						/* sub menu */
						openedDropdowns.find((item) => item === "3") && (
							<div className="alm_sub-menu">
								{/* SUB NAV ITEM */}
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/products`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Products
									</NavLink>
								</div>

								{/* SUB NAV ITEM */}
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/categories`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Categories
									</NavLink>
								</div>

								{/* SUB NAV ITEM */}
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/brands`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Brands
									</NavLink>
								</div>

								{/* SUB NAV ITEM */}
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/coupons`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Coupons
									</NavLink>
								</div>

								{/* SUB NAV ITEM */}
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/vendors`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Vendors
									</NavLink>
								</div>

								{/* SUB NAV ITEM */}
								{/* <div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/purchase-orders`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Purchase Orders
									</NavLink>
								</div> */}

								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/multipliers`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Multipliers
									</NavLink>
								</div>
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/blogs`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Blogs
									</NavLink>
								</div>

								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/sliders`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Sliders
									</NavLink>
								</div>

								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/catalog/testimonials`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Testimonials
									</NavLink>
								</div>
							</div>
						)
					}
				</div>

				{/* NAV ITEM */}
				<div className="alm_nav-item">
					{/* NAV LINK */}
					<NavLink
						data-id="6"
						to="/settings"
						activeClassName="opened"
						className={`
                            alm_nav-link text-decoration-none d-flex align-items-center
                            ${openedDropdowns.find((item) => item === "6")
								? "active"
								: ""
							}
                        `}
						onClick={(ev) => handleSubMenuVisibility(ev, "6")}
					>
						{/* left sec */}
						<div className="lt d-flex media-body">
							<FeatherIcon icon="settings" size="15" className="icon" />
							<span>Settings</span>
						</div>

						{/* right sec */}
						<div className="rt text-center">
							<FeatherIcon icon="chevron-right" size="15" className="icon" />
						</div>
					</NavLink>

					{
						/* sub menu */
						openedDropdowns.find((item) => item === "6") && (
							<div className="alm_sub-menu">
								{/* SUB NAV ITEM */}
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/settings/users`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Users
									</NavLink>
								</div>

								{/* SUB NAV ITEM */}
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/settings/emails`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Email Templates
									</NavLink>
								</div>
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/settings/integration`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Integration
									</NavLink>
								</div>
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/settings/manage`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Manage
									</NavLink>
								</div>
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/settings/payment`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Payment
									</NavLink>
								</div>
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/settings/shippings`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Shipping & Pickup
									</NavLink>
								</div>
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/settings/notifications`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Notifications
									</NavLink>
								</div>
								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/settings/product-types`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Product Types
									</NavLink>
									<NavLink
										to={`${storeUrl}/settings/product-filters`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Product Filters
									</NavLink>
								</div>

								<div className="alm_sub-nav-item">
									<NavLink
										to={`${storeUrl}/my-sales/google-shopping`}
										activeClassName="opened"
										className="alm_sub-nav-link text-decoration-none d-flex align-items-center"
									>
										Google Shopping
									</NavLink>
								</div>
							</div>
						)
					}
				</div>

				{/* fraction */}
				{/* <div className="frac">
                    <div className="frac-inner">
                    </div>
                </div> */}
			</div>
		</div>
	);
}

const getDataFromStore = (state) => {
	return {
		sideBarVisibility: state.common.sideBarVisibility,
	};
};

const dispatchActionsToProps = (dispatch) => {
	return {
		setSideBarStatus: (bool) => dispatch(setSideBarStatus(bool)),
	};
};

export default connect(getDataFromStore, dispatchActionsToProps)(AppLeftMenu);
